import React from "react";
import { Container } from "react-bootstrap";

import ManualInvitations from "../components/invitations/ManualInvitations";

function Invitations() {
  return (
    <div>
      <ManualInvitations />
    </div>
  );
}

export default Invitations;
